import {
    Box,
    Grid,
    Typography,
    CardMedia,
    IconButton,
    Divider,
    Stack,
    Fab
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import logo from "../images/logo.png";

export default function Footer() {
    const handleEmail = () => {
        window.location.href = "mailto:info@dreamflyholiday.com";
    };

    const newTab = (url) => {
        window.open(url, "_blank");
    };

    return (
        <Box sx={{ bgcolor: "#454545", color: "white", px: 3, pt: 6 }}>
            <Grid container spacing={4} justifyContent="center">
                {/* Logo & Description */}
                <Grid item size={{xs:12, md:2.5, lg:2.5}}>
                    <CardMedia component="img" image={logo} alt="Logo" sx={{ width: 150, mb: 2 }} />
                    <Typography variant="body2">
                        A tour & travel company, providing modified travel solutions for clients all over the world.
                    </Typography>
                </Grid>

                {/* Legal */}
                <Grid item size={{xs:6, md:3, lg:3}}>
                    <Typography variant="h6" gutterBottom>Legal Policy</Typography>
                    <Divider sx={{ width: 50, height:3, backgroundColor: "#774E33", mb: 1 }} />
                    <Typography variant="body2" sx={{ cursor: "pointer", my: 0.5 }}>Disclaimer</Typography>
                    <Typography variant="body2" sx={{ cursor: "pointer", my: 0.5 }}>Terms & Conditions</Typography>
                    <Typography variant="body2" sx={{ cursor: "pointer", my: 0.5 }}>Privacy Policy</Typography>
                </Grid>

                {/* Contact */}
                <Grid item size={{xs:6, md:3, lg:3}}>
                    <Typography variant="h6" gutterBottom>Contact Us</Typography>
                    <Divider sx={{ width: 50, height:3,backgroundColor: "#774E33", mb: 1 }} />
                    <Typography variant="body2">Sector 53, Noida</Typography>
                    <Typography variant="body2">9643751779, 7042104648</Typography>
                    <Typography
                        variant="body2"
                        sx={{ cursor: "pointer", textDecoration: "underline", mt: 1 }}
                        onClick={handleEmail}
                    >
                        info@dreamflyholiday.com
                    </Typography>
                </Grid>

                {/* Map */}
                <Grid item size={{xs:12, md:3.5, lg:3.5}} sx={{height:"150px"}}>
                    <Typography variant="h6" gutterBottom>Location</Typography>
                    <Divider sx={{ width: 50, height:3,backgroundColor: "#774E33", mb: 1 }} />
                    <iframe
                        title="Map"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ borderRadius: "10px" }}
                        loading="lazy"
                        src="https://www.google.com/maps?q=Dream+Fly+Holiday,+2nd+floor,+MS+complex,+Gijhore,+sector+53,+Noida&output=embed"
                    />
                </Grid>
            </Grid>

            {/* Payment Methods */}
            {/* <Box sx={{ fontSize: '16px', textTransform: 'uppercase', fontWeight: "bold", px: 2 }} mt={5}>
                <Typography variant="h6" gutterBottom>Payment Methods</Typography>
                <Stack direction="row" spacing={2} mt={1}>
                    <CardMedia component="img" height="40" image="https://cdn-icons-png.flaticon.com/512/825/825454.png" alt="Paytm" />
                    <CardMedia component="img" height="40" image="https://cdn.iconscout.com/icon/free/png-256/free-google-pay-logo-icon-download-in-svg-png-gif-file-formats--gpay-payment-money-pack-logos-icons-1721670.png" alt="GPay" />
                    <CardMedia component="img" height="40" image="https://cdn-icons-png.flaticon.com/512/825/825455.png" alt="ApplePay" />
                </Stack>
            </Box> */}

            {/* Social Media Icons */}
            <Box mt={7} textAlign="center">
                <Typography variant="h6" gutterBottom>Follow us on:</Typography>
                <Stack direction="row" spacing={3} justifyContent="center" mt={1}>
                    <IconButton onClick={() => newTab("https://www.facebook.com/profile.php?id=100085047715808&mibextid=JRoKGi")} sx={{ color: "white" }}><FacebookIcon fontSize="large" /></IconButton>
                    <IconButton onClick={() => newTab("https://www.instagram.com/dreamflyholiday?igsh=MXBhdmtrbG1jeGgzNg==")} sx={{ color: "white" }}><InstagramIcon fontSize="large" /></IconButton>
                    <IconButton onClick={() => newTab("https://twitter.com")} sx={{ color: "white" }}><TwitterIcon fontSize="large" /></IconButton>
                    <IconButton onClick={() => newTab("https://www.youtube.com/@dreamflyholiday4935")} sx={{ color: "white" }}><YouTubeIcon fontSize="large" /></IconButton>
                </Stack>
            </Box>

            {/* Copyright */}
            <Typography variant="body2" textAlign="center" mt={5} sx={{ borderTop: "1px solid #fff", pt: 2 }}>
                © {new Date().getFullYear()} DreamFLY Holiday. All rights reserved.
            </Typography>

            {/* Floating CTA Buttons */}
            <Box sx={{ position: "fixed", bottom: 30, left: 20, zIndex: 1000 }}>
                <Stack direction="row" spacing={2}>
                    <Fab
                        color="primary"
                        href="tel:9643751779"
                        sx={{ borderRadius: '50%', width: 56, height: 56 }}
                    >
                        <PhoneIcon />
                    </Fab>

                    <Fab
                        color="success"
                        href="https://wa.me/9643751779"
                        sx={{ borderRadius: '50%', width: 56, height: 56 }}
                    >
                        <WhatsAppIcon />
                    </Fab>
                </Stack>

            </Box>

        </Box>
    );
}
